import { AuctionItem } from '../models/auction-item';
import { AssetMapper } from './asset.mapper';

export class AuctionItemMapper {
  public static mapItems(auctionItems: AuctionItem[]): AuctionItem[] {
    return auctionItems.map(AuctionItemMapper.mapItem);
  }
  public static mapItem(auctionItem: AuctionItem): AuctionItem {
    auctionItem.topBidAmount = auctionItem.topBidAmount ?? 0;
    auctionItem.assets = AssetMapper.mapItems(auctionItem.assets, auctionItem.auctionId);
    const assets = auctionItem.assets;
    auctionItem.imageUrl =
      assets && assets.length
        ? assets[0].imageUrl
        : 'assets/images/no-image-available.png';
    return auctionItem;
  }
}
